<div>
    <div class="address-header">
        <span [innerHTML]="addressHeaderText | translate | safeHtml"></span>
    </div>

    <div class="section__col section__col--3 section__col--custom-rwd">
        <div class="section__field">
            <app-text-field-edit    [config]="ownerNameTextFieldEditConfig"
                                    (onAction)="editPersonData()">
            </app-text-field-edit>
        </div>

        <div *ngIf="isNext" class="section__field">
            <app-text-field-edit    [config]="ownerPeselTextFieldEditConfig"
                                    (onAction)="editPersonData()">
            </app-text-field-edit>
        </div>

        <div *ngIf="isNext" class="section__field section__field--empty"></div>

        <div class="section__field">
            <app-text-field-edit    [config]="postalCodeTextFieldEditConfig"
                                    (onAction)="editPersonData()">
            </app-text-field-edit>
        </div>

        <div class="section__field">
            <ng-container *ngIf="isDictionaryMode; else cityStandardMode">
                <app-select #citySelect [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.CITY]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.CITY, formConfig)"
                            [context]="formConfig.formKey"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </ng-container>
            <ng-template #cityStandardMode>
                <app-text-field [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.CITY]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.CITY, formConfig)"
                                [context]="formConfig.formKey"
                                [customMetrics]="customMetricsData(index)"
                                (changeEvent)="onFieldChange($event)"
                                (interactiveClick)="sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </ng-template>
        </div>

        <div *ngIf="isNext" class="section__field section__field--empty"></div>

        <div class="section__field" *ngIf="countyVisible">
            <app-text-field [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.COUNTY]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.COUNTY, formConfig)"
                            [context]="formConfig.formKey"
                            [customMetrics]="customMetricsData(index)"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="sendCheckoutElementClickEvent($event)"
            >
            </app-text-field>
        </div>

        <div class="section__field">
            <ng-container *ngIf="stateService.isStreetSelect; else streetStandardMode">
                <app-select #streetSelect [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.STREET]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.STREET, formConfig)"
                            [context]="formConfig.formKey"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </ng-container>
            <ng-template #streetStandardMode>
                <app-text-field [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.STREET]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.STREET, formConfig)"
                                [context]="formConfig.formKey"
                                [customMetrics]="customMetricsData(index)"
                                (changeEvent)="onFieldChange($event)"
                                (interactiveClick)="sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </ng-template>
        </div>

        <div class="section__field">
            <app-text-field [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.BUILDING_NUMBER]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.BUILDING_NUMBER, formConfig)"
                            [context]="formConfig.formKey"
                            [customMetrics]="customMetricsData(index)"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="sendCheckoutElementClickEvent($event)"
            >
            </app-text-field>
        </div>

        <div class="section__field">
            <app-text-field [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.FLAT_NUMBER]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.FLAT_NUMBER, formConfig)"
                            [context]="formConfig.formKey"
                            [customMetrics]="customMetricsData(index)"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="sendCheckoutElementClickEvent($event)"
            >
            </app-text-field>
        </div>
    </div>
</div>
